<template>
    <section>

        <transition name="fade">
            <div v-if="error" class="notifix notifix-error">
                <i class="fa fa-times" style="position: absolute;top: 1rem;right: 1rem; cursor:pointer;" aria-label="close" @click="error=null"></i>
                <p>{{error}}</p>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="success" class="notifix notifix-success">
                <i class="fa fa-times" style="position: absolute;top: 1rem;right: 1rem; cursor:pointer;" aria-label="close" @click="success=null"></i>

                <p>{{success}}</p>
            </div>
        </transition>

        <div class="f-contact-header">
        </div>
        <div class="contact container">
            <div class="f-contact-title">
                <div>
                    <h1>CONTACTOS</h1>
                    <nav class="breadcrumb has-succeeds-separator is-small" style="cursor:pointer" aria-label="breadcrumbs">
                        <ul>
                            <router-link tag="li" to="/home">&nbsp;HOME&nbsp;</router-link>
                            <router-link tag="li" to="contacto">&nbsp;CONTACTOS&nbsp;</router-link>
                        </ul>
                    </nav>
                </div>
                <div class="contact-icon" style="margin-left:auto;">
                    <i class="fa fa-clock-o fa-2x"></i>
                    <h3>HORÁRIO</h3>
                    <p>Seg. a Sex. feira</p>
                    <p>9h - 13h | 14h - 18h</p>

                </div>
                <div class="contact-icon">
                    <i class="fa fa-envelope fa-2x"></i>
                    <h3>EMAIL</h3>
                    <p>suporte@facilimo.pt</p>
                    <p>comunicacao@facilimo.pt</p>

                </div>
            </div>
            <div class="contact-form-map">
                <div class="columns">
                    <div class="column is-5">

                        <h2>
                            Coloque as suas dúvidas ou sugestões aqui...<br>
                            Prometemos ser breves a dar uma resposta!
                        </h2>
                        <form @submit.prevent="validateBeforeSubmit">

                            <input id="name" name="name" v-validate="'required'" data-vv-as="nome" v-model="name" class="input" type="text" placeholder="Nome">
                            <p v-show="errors.has('name')" class="form-help has-text-primary">{{ errors.first('name') }}</p>

                            <input id="email" name="email" v-model="email" v-validate="'required|email'" data-vv-as="e-mail" class="input" type="email" placeholder="E-mail">
                            <p v-show="errors.has('email')" class="form-help has-text-primary">{{ errors.first('email') }}</p>



                            <div class="fakeddcontainer">
                                <p :class="[{ 'gray' : subjectReset }]" class="fakedd" @click="ddfakeopen = true"> {{subject}} <i class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#2d3256"></i></p>
                                <input id="subject" type="text" v-validate="'required|not_in:Assunto'" data-vv-as="assunto" v-model="subject" name="subject" placeholder="Assunto" style="display: none;">
                                <div v-if="ddfakeopen" class="ddfake-open">
                                    <p class="ddfake-opt" @click="subject = 'Dúvida'; ddfakeopen = false;">Dúvida</p>
                                    <p class="ddfake-opt" @click="subject = 'Registo'; ddfakeopen = false;">Registo</p>
                                    <p class="ddfake-opt" @click="subject = 'Sugestão'; ddfakeopen = false;">Sugestão</p>
                                    <p class="ddfake-opt" @click="subject = 'Outro'; ddfakeopen = false;">Outro</p>
                                </div>
                            </div>
                            <p v-show="errors.has('subject')" class="form-help has-text-primary">{{ errors.first('subject') }}</p>

                            <textarea name="message" id="message" v-validate="'required'" data-vv-as="mensagem" v-model="message" class="textarea"  placeholder="A sua mensagem"></textarea>
                            <p v-show="errors.has('message')" class="form-help has-text-primary">{{ errors.first('message') }}</p>


                            <div class="field mb0">
                                <div class="file is-white has-name">
                                    <label class="file-label">
                                        <input @change="handle" ref="file" class="file-input" type="file" name="file" accept=".doc,.docx,.pdf,.png,.jpg,.jpeg,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/png,image/jpeg,text/plain">
                                        <span class="file-cta">
                                        <span class="file-icon">
                                          <i class="fa fa-paperclip"></i>
                                        </span>
                                        <span class="file-label">
                                         Anexo
                                        </span>
                                      </span>
                                        <span class="file-name">
                                        {{file ? file.name : "Nome do ficheiro"}}
                                      </span>
                                    </label>
                                </div>
                            </div>
                            <p class="form-help">Máximo de 2 MB de tamanho.</p>


                            <div class="field">
                                <div class="control">
                                    <a class="button is-info" @click="send"> ENVIAR MENSAGEM</a>

                                </div>
                            </div>

                        </form>
                    </div>
                    <div id="mapcol" class="column is-6 is-offset-1">
                        <iframe
                                id="mapFrame"
                                width="450"
                                height="450"
                                frameborder="0" style="border:0"
                                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBl_w8sFJDiONtBRB1ufaGaMdeO057RuDk
    &q=Centro,+Leiria+Portugal&language=pt_PT" allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>


    </section>
</template>

<script>
import SearchDropDown from "../components/SearchDropDown.vue";
import { notificationMixin } from "../plugins/notificationMixin";
import { removeChatMixin } from "../plugins/removeChatMixin";
import { apiUrl } from "../vars";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
  mixins: [notificationMixin, removeChatMixin, scrollTop],
  components: {
    SearchDropDown
  },
  data() {
    return {
      name: null,
      email: null,
      subject: "Assunto",
      message: null,
      file: null,
      ddfakeopen: false
    };
  },

  mounted() {
    let frame = document.getElementById("mapFrame");
    let mapcol = document.getElementById("mapcol");
    let computedStyle = getComputedStyle(mapcol);
    let elementHeight = mapcol.clientHeight; // height with padding
    let elementWidth = mapcol.clientWidth; // width with padding

    elementHeight -=
      parseFloat(computedStyle.paddingTop) +
      parseFloat(computedStyle.paddingBottom);
    elementWidth -=
      parseFloat(computedStyle.paddingLeft) +
      parseFloat(computedStyle.paddingRight);
    frame.width = elementWidth;
    frame.height = elementHeight;
  },

  computed: {
    subjectReset: function() {
      return this.subject === "Assunto";
    }
  },
  methods: {
    handle(e) {
      this.file = this.$refs.file.files[0];

      let allowedTypes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
        "image/png",
        "image/jpeg",
        "text/plain"
      ];

      if (this.file && allowedTypes.indexOf(this.file.type) === -1) {
        this.error = "Formato de ficheiro não suportado.";
        this.file = null;
        return;
      }

      if (this.file && this.file.size > 2097152) {
        this.error = "O tamanho do ficheiro excede 2 MB.";
        this.file = null;
      }
    },

    send() {
      let that = this;
      let formData = new FormData();
      if (this.file) {
        formData.append("file", this.file);
        formData.append("filename", this.file.name);
        formData.append("type", this.file.type);
      }

      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("subject", this.subject);
      formData.append("message", this.message);

      axios
        .post(apiUrl + "/api/contacto", formData)
        .then(function(res) {
          that.success = "Mensagem enviada com sucesso.";
          that.name = null;
          that.email = null;
          that.subject = "Assunto";
          that.message = null;
          that.file = null;
        })
        .catch(function(err) {
          that.error = "Falha ao enviar a mensagem. " + err.statusText;
        });
    },

    validateBeforeSubmit() {
      let that = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          that.send();
          return;
        }
        that.error = "Por favor, preencha todos os campos.";
      });
    }
  },
  created() {},
  destroyed() {}
};
</script>
<style scoped>
.gray {
  color: #b6b6b6 !important;
}

.fakeddcontainer {
  position: relative;
}
.fakedd {
  position: relative;
  margin: 1.5rem 0 0;
  border: solid 1px #2d3256;
  line-height: 2rem;
  padding: 0 0.5rem;
  //color: #b6b6b6;
}

.ddfake-open {
  background-color: white;
  position: absolute;
  z-index: 2;
  width: 100%;
  border: solid 1px #969696;
}
.ddfake-opt {
  color: black;
  line-height: 2rem;
  z-index: 3;
  cursor: pointer;
  padding: 0 0.5rem;
}
.ddfake-opt:hover {
  color: white;
  background-color: #2d3256;
}

.form-help {
  margin-top: 0.2rem;
  font-size: 0.6rem;
  font-style: italic;
  font-weight: 300;
}

.f-contact-header {
  background-image: url("/static/images/contact/imagemtopo.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 10rem;
}

.contact.container {
  margin-top: -3rem;
  background-color: white;
}
.f-contact-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.f-contact-title h1 {
  color: #2d3256;
  font-weight: 700;
  font-size: 2rem;
}

.contact-icon {
  text-align: center;
  padding: 0 1rem;
}

.contact-icon i {
  color: #e90054;
}

.contact-icon h3 {
  color: #2d3256;
  font-weight: 500;
  font-size: 1rem;
}

.contact-icon p {
  color: #969696;
  font-size: 0.6rem;
}

.contact-form-map {
  padding: 1.5rem 0 4rem;
}

.contact-form-map h2 {
  color: #2d3256;
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 1.5rem;
}

.input {
  margin: 1.5rem 0 0;
  border: solid 1px #2d3256;
  line-height: 2rem;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #969696;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #969696;
  opacity: 1;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #969696;
  opacity: 1;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #969696;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #969696;
}

::placeholder {
  /* Most modern browsers support this now. */
  color: #969696;
}

.textarea {
  margin: 1.25rem 0 0;
  border: solid 1px #2d3256;
  line-height: 1.5rem;
}

.select {
  margin: 1.5rem 0 0;
  //border: solid 1px #2d3256;
  outline: solid 1px #2d3256;
  line-height: 1.5rem;
}

.file {
  margin: 1.5rem 0 0;
  background-color: white;
  border: solid 1px #2d3256;
}

.file-cta {
  border: solid 1px white !important;
  outline: solid 1px #2d3256 !important;
}

.file-name {
  border: none;
  color: #969696;
  font-size: 0.9rem;
  line-height: 1.75rem;
}

.button {
  margin: 1.5rem 0 0;
  font-weight: 600;
  padding: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue